import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();

  const isLoginPage = location.pathname === '/login';

  return (
    <header className="bg-gray-800 text-white p-4 flex justify-between items-center">
      <Link to="/home" className="text-xl font-bold hover:text-gray-300">
        Qercha
      </Link>
      <nav className="space-x-4 flex items-center">
        {user && (
          <span className="mr-2">
            Welcome, <strong>{user.username}</strong>
          </span>
        )}

        {isLoginPage ? (
          <>
            <Link to="/home" className="hover:font-bold hover:underline hover:text-gray-300">Home</Link>
            <Link to="/register" className="hover:font-bold hover:underline hover:text-gray-300">Register</Link>
          </>
        ) : (
          <>
            {!user ? (
              <>
                <Link to="/home" className="hover:font-bold hover:underline hover:text-gray-300">Home</Link>
                <Link to="/login" className="hover:font-bold hover:underline hover:text-gray-300">Login</Link>
                <Link to="/register" className="hover:font-bold hover:underline hover:text-gray-300">Register</Link>
              </>
            ) : (
              <>
                <Link to="/home" className="hover:font-bold hover:underline hover:text-gray-300">Home</Link>
                <button
                  onClick={() => {
                    localStorage.removeItem('user');
                    window.location.href = '/login';
                  }}
                  className="hover:font-bold hover:underline hover:text-gray-300"
                >
                  Logout
                </button>
              </>
            )}
          </>
        )}
      </nav>
    </header>
  );
}
